<script setup>

import KdAccountUnitAnalystAudit from "./kdAccountUnitAnalystAudit.vue";
import KdAccountUnitUploadInventoryHandStatusAudit from "./kdAccountUnitUploadInventoryHandStatusAudit.vue";
import KdAccountUnitWriteFinishStatusAudit from "./kdAccountUnitWriteFinishStatusAudit.vue";
import KdAccountUnitWritePermanentSolutionAudit from "./kdAccountUnitWritePermanentSolutionAudit.vue";
import KdMarketEngineerAudit from "./kdMarketEngineerAudit.vue";
import KdMarketingManagerAudit from "./kdMarketingManagerAudit.vue";
import KdNormalAudit from "./kdNormalAudit.vue";
import KdQeAssignAccountUnitAudit from "./kdQeAssignAccountUnitAudit.vue";
import KdQeCheckAndUploadBreakPointInfoAudit from "./kdQeCheckAndUploadBreakPointInfoAudit.vue";
import KdQeEnsurePermanentSolutionAudit from "./kdQeEnsurePermanentSolutionAudit.vue";
import KdQeReasonAnalystAudit from "./kdQeReasonAnalystAudit.vue";
import KdQeVehicleDisposalPlanForTheOutputMarketAudit from "./kdQeVehicleDisposalPlanForTheOutputMarketAudit.vue";
import kdQeVehicleDisposalPackMarketAudit from "./kdQeVehicleDisposalPackMarketAudit.vue";
import KdQeVehicleDisposalPackMarketSchemeAudit from "./kdQeVehicleDisposalPackMarketSchemeAudit.vue";
import KdQualityEngineerCloseAudit from "./kdQualityEngineerCloseAudit.vue";
import KdQualityManagerInitiateRecallAudit from "./kdQualityManagerInitiateRecallAudit.vue";
import KdQualityReasonAnalystAudit from "./kdQualityReasonAnalystAudit.vue";
import KdReasonAnalystAudit from "./kdReasonAnalystAudit.vue";
import KdSolutionAudit from "./kdSolutionAudit.vue";
import KdQualityManagerUpgradeAudit from "./kdQualityManagerUpgradeAudit.vue";
import KdManagerSubmit from "./kdManagerSubmit.vue";
import KdQualitySolutionMaterialAudit from "./kdQualitySolutionMaterialAudit.vue";
import KdQeSkillManagerPackMarketSchemeAudit from "./kdQeSkillManagerPackMarketSchemeAudit.vue";
import KdQualityManagerInitiateUnitAudit from "./kdQualityManagerInitiateUnitAudit.vue";
import KdServeInventoryHandStatusAudit from "./kdServeInventoryHandStatusAudit.vue";
</script>

<template>
    <div class="audit-form-main">
        <kd-account-unit-analyst-audit  :taskId="taskId" v-if="taskDefKey === 'accountUnitAnalystAudit'"></kd-account-unit-analyst-audit>

        <kd-account-unit-upload-inventory-hand-status-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey"
                                                            :marketVehicles="marketVehicles"
                                                         v-if="taskDefKey === 'Activity_09gocxv' ||
                                                         taskDefKey === 'Activity_1qakyfn' ||
                                                         taskDefKey === 'Activity_1n4y57e' ||
                                                     taskDefKey === 'Activity_1q5528k' ">
        </kd-account-unit-upload-inventory-hand-status-audit>

      <kd-serve-inventory-hand-status-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :marketVehiclesList="marketVehiclesList"
                                            :inventoryVehicleHandStatusMessage="inventoryVehicleHandStatusMessage"
                                                          v-if="taskDefKey === 'Activity_0e8nzr5'||
                                                     taskDefKey === 'Activity_1jrizcd'">
      </kd-serve-inventory-hand-status-audit>

      <kd-account-unit-write-finish-status-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :receivedForm="receivedForm"
                                                v-if="taskDefKey === 'Activity_160anpw' ||
                                                taskDefKey === 'Activity_0mwkwpr'
     "></kd-account-unit-write-finish-status-audit>

        <kd-account-unit-write-permanent-solution-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :receivedForm="receivedForm"
                                                     v-if="taskDefKey === 'Activity_0urc73r' ||
                                                      taskDefKey === 'Activity_1m5s9p9'
                                                      ">
        </kd-account-unit-write-permanent-solution-audit> <!--  责任单位填写永久方案和计划改善时间-->

        <kd-market-engineer-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                               v-if="taskDefKey === 'Activity_1a7qzv5' ||
                                taskDefKey === 'Activity_0g2kdpo' ||
                                taskDefKey === 'Activity_1pp3lzj' ||
                                taskDefKey === 'Activity_157te0n' ||
                                taskDefKey === 'Activity_11t4h10' ">
        </kd-market-engineer-audit> <!--  市场工程师审核永久方案 断点时间-->

      <!--  市场工程师指定QE人员-->
      <kd-marketing-manager-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :countryDataId="countryDataId"
                                 v-if="taskDefKey === 'Activity_152lqau' || taskDefKey === 'Activity_0wvd52t'"></kd-marketing-manager-audit>

      <kd-normal-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey"
                      v-if="taskDefKey === 'Activity_0wh76h6' ||
                      taskDefKey === 'Activity_0vptm0p' || taskDefKey === 'Activity_1hq957q'">
      </kd-normal-audit>


        <kd-qe-assign-account-unit-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems" :marketVehiclesList="marketVehiclesList"
                                      v-if="taskDefKey === 'Activity_0th0wyq' ||
                                      taskDefKey === 'Activity_0xqs0a8'  ||
                                      taskDefKey === 'Activity_1ymzrv7'  ||
                                      taskDefKey === 'Activity_187ssqr'  ||
                                      taskDefKey === 'Activity_074ozpu'"  >
        </kd-qe-assign-account-unit-audit><!--  QE指定责任单位人员-->

        <kd-qe-check-and-upload-break-point-info-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                                                    v-if="taskDefKey === 'Activity_1348h5u' ||
                                                    taskDefKey === 'Activity_13bppvj' ">
        </kd-qe-check-and-upload-break-point-info-audit> <!--  QE验证并上传断点信息-->

        <kd-qe-ensure-permanent-solution-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                                            v-if="taskDefKey === 'Activity_0nw86wc' ||
                                                  taskDefKey === 'Activity_10n9bqm' ">
        </kd-qe-ensure-permanent-solution-audit> <!--  QE审核永久方案-->

        <kd-qe-reason-analyst-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems" :problemType="problemType"
                                 v-if="taskDefKey === 'Activity_18tjzgb' || taskDefKey === 'Activity_150gfp6'" ></kd-qe-reason-analyst-audit> <!--  QE审核根因分析 || 结束流程审批节点-->

        <kd-qe-vehicle-disposal-plan-for-the-output-market-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :marketVehicles="marketVehicles"
                                                              v-if="taskDefKey === 'Activity_06py48i' ||
                                                               taskDefKey === 'Activity_0ssx6ld' ||
                                                               taskDefKey === 'Activity_1nh3hwe' ||
                                                               taskDefKey === 'Activity_1swuo28' ||
                                                               taskDefKey === 'Activity_0zd71x8' ||
                                                               taskDefKey === 'Activity_0vmay8b' ||
                                                               taskDefKey === 'Activity_1nxlt2k' ||
                                                               taskDefKey === 'Activity_119d7lh'">
        </kd-qe-vehicle-disposal-plan-for-the-output-market-audit> <!--  QE输出KD工厂物料及库存物料处置方案-->


<!--      <kd-qe-vehicle-disposal-pack-market-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :marketVehicles="marketVehicles"-->
<!--                                                               v-if="taskDefKey === 'Activity_1qy6vq8'">-->
<!--      </kd-qe-vehicle-disposal-pack-market-audit>-->

      <kd-qe-skill-manager-pack-market-scheme-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :marketVehiclesList="marketVehiclesList"
                                                v-if="taskDefKey === 'Activity_1my3ohs' ||
                                                      taskDefKey === 'Activity_1rsap6m' ||
                                                      taskDefKey === 'Activity_1qy6vq8'">
      </kd-qe-skill-manager-pack-market-scheme-audit>

      <kd-qe-vehicle-disposal-pack-market-scheme-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey"
                                                       :hasMarketVehicle="hasMarketVehicle"
                                                       :hasInventoryVehicle="hasInventoryVehicle"
                                                v-if="taskDefKey === 'Activity_04naygw' ">
      </kd-qe-vehicle-disposal-pack-market-scheme-audit>  <!--  KD-包装责任单位输出市场物料及未发物料处置及补发方案-->

        <kd-quality-engineer-close-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey"
                                         :suggestionItems="suggestionItems"
                                     :factoryVerificationSituation="factoryVerificationSituation"
                                      :factoryVerificationSituationFiles="factoryVerificationSituationFiles"
                                      v-if="taskDefKey === 'Activity_1xjhayn' ||
                                      taskDefKey === 'Activity_0qhj6rd' ||
                                      taskDefKey === 'Activity_0rjx76r'  ">
        </kd-quality-engineer-close-audit> <!--  21.2-KD-服务经理填写KD工厂验证情况,23.2-KD-质量工程师关闭 -->

        <kd-quality-manager-initiate-recall-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :marketVehicles="marketVehicles"
                                               v-if="taskDefKey === 'Activity_02i0f7v' ||
                                               taskDefKey === 'Activity_16fs05f' ||
                                               taskDefKey === 'Activity_0rr8epy'
                                               ">
        </kd-quality-manager-initiate-recall-audit>


      <kd-quality-manager-initiate-unit-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :marketVehicles="marketVehicles"
                                                v-if="taskDefKey === 'Activity_1klkn9j' ">
      </kd-quality-manager-initiate-unit-audit>

        <kd-quality-reason-analyst-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                                         :qualityEnd= "qualityEnd" :problemType="problemType"
                                      v-if="taskDefKey === 'Activity_070sjiw' ||
                                       taskDefKey === 'Activity_0vnhfut' ||
                                       taskDefKey === 'Activity_00hrf3u' ||
                                       taskDefKey === 'Activity_0frj90o' ||
                                       taskDefKey === 'Activity_1w5edej' ||
                                       taskDefKey === 'Activity_0wvr9ix'">
        </kd-quality-reason-analyst-audit> <!--  质量改善部部长审核根因分析材料-->

      <kd-quality-solution-material-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :suggestionItems="suggestionItems"
                              v-if="taskDefKey === 'Activity_0odad8y'">
        </kd-quality-solution-material-audit>

        <kd-reason-analyst-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :reasonAnalystData="reasonAnalystData"
                              v-if="taskDefKey === 'Activity_18nq1e5' ||
                               taskDefKey === 'Activity_009xhan' ||
                               taskDefKey === 'Activity_1vwk38v' ||
                               taskDefKey === 'Activity_0q3vnwm' ||
                               taskDefKey === 'Activity_0ataghk'">
        </kd-reason-analyst-audit> <!--  责任单位判断是否差缺根因分析材料-->

      <kd-solution-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :replenish= "replenish" :problemType="problemType"
                      v-if="taskDefKey === 'Activity_1ayglqh' ||
                      taskDefKey === 'Activity_1jmu1ad'">
      </kd-solution-audit> <!--  技术经理判断问题类型，质量经理审批-->
<!--      <kd-quality-manager-upgrade-audit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey" :provisionalMeasures="provisionalMeasures"-->
<!--                                     v-if="taskDefKey === 'Activity_1jmu1ad'"></kd-quality-manager-upgrade-audit>-->

      <kd-manager-submit :taskId="taskId" :questionId="questionId" :taskDefKey="taskDefKey"
                      v-if="taskDefKey === 'Activity_1r5u2c8' || taskDefKey === 'Activity_1lvb0jl'"></kd-manager-submit> <!--  服务经理再次提交-->


    </div>
</template>

<style scoped lang="scss">

</style>
<script>
import {requestTaskDetail} from "../../api/feedback";

export default {
  name: "switchMainAudit",
  props: {
    taskId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
        taskDefKey: "",
        questionId: "",
        countryDataId: "",
        taskDetail:{
          taskId: ""
        },
      suggestionItems: [],
      marketVehiclesList: [],
      qualityEnd: false,
      pdiMessage: "",
      pdiCheckResult: "",
      replenish: false,
      hasMarketVehicle: 1,
      hasInventoryVehicle: 1,
      inventoryVehicleHandStatusMessage: '',
      problemType: "",
      marketVehicles: {},
      reasonAnalystData: {},
      reconfirm: false,
      factoryVerificationSituation: '',
      pdiCheckResultFiles: [],
      factoryVerificationSituationFiles: [],
      pdiMessageFile: [],
      receivedForm: {
        reasonAnalystMaterial: "",
        reasonAnalyst: "",
        file:[]
      },
    }
  },
  components: {
  },
  methods: {
    loadTaskDetail(){
      let taskId = this.taskId;
      let searchParam = new URLSearchParams();
      searchParam.append("taskId", taskId)
      requestTaskDetail(searchParam).then(res => {
        if(res.status == "0"){
            this.taskDetail = res.data;
            this.taskDefKey = res.data.taskDefKey;
            this.questionId = res.data.variables.questionId;
            this.countryDataId = res.data.variables.countryDataId;
            if (this.taskDefKey == "Activity_18tjzgb" ||
              this.taskDefKey == "Activity_070sjiw" ||
              this.taskDefKey == "Activity_150gfp6" ||
              this.taskDefKey == "Activity_0vnhfut" ||
              this.taskDefKey == "Activity_0odad8y" ||
              this.taskDefKey == "Activity_0frj90o" ||
              this.taskDefKey == "Activity_0th0wyq" ||
              this.taskDefKey == "Activity_1ymzrv7" ||
              this.taskDefKey == "Activity_0xqs0a8" ||
              this.taskDefKey == "Activity_074ozpu" ||
              this.taskDefKey == "Activity_00hrf3u" ||
              this.taskDefKey == "Activity_1w5edej" ||
              this.taskDefKey == "Activity_0wvr9ix" ||
              this.taskDefKey == "Activity_0nw86wc" ||
              this.taskDefKey == "Activity_10n9bqm" ||
              this.taskDefKey == "Activity_1348h5u" ||
              this.taskDefKey == "Activity_13bppvj" ||
              this.taskDefKey == "Activity_1a7qzv5" ||
              this.taskDefKey == "Activity_0g2kdpo" ||
              this.taskDefKey == "Activity_11t4h10" ||
              this.taskDefKey == "Activity_157te0n" ||
              this.taskDefKey == "Activity_1pp3lzj" ||
              this.taskDefKey == "Activity_1wqnwvf" ||
              this.taskDefKey == "Activity_0ioza48" ||
              this.taskDefKey == "Activity_00kcjof" ||
              this.taskDefKey == "Activity_0qhj6rd" ||
              this.taskDefKey == "Activity_0rjx76r" ||
              this.taskDefKey == "Activity_1xjhayn"){ // 回填根音分析材料 断点时间 永久方案 等
              this.suggestionItems = res.data.variables.reasonAnalystDataList;
              if (res.data.variables.qualityEnd != null){
                this.qualityEnd = res.data.variables.qualityEnd;
              }
              if (res.data.variables.problemType != null){
                this.problemType = res.data.variables.problemType;
              }
              if (res.data.variables.pdiMessage != null){
                this.pdiMessage = res.data.variables.pdiMessage;
                this.pdiMessageFile = res.data.variables.pdiMessageFile;
              }
              if (res.data.variables.pdiCheckResult != null){
                this.pdiCheckResult = res.data.variables.pdiCheckResult;
                this.pdiCheckResultFiles = res.data.variables.pdiCheckResultFiles;
              }
              if (res.data.variables.factoryVerificationSituation != null){
                this.factoryVerificationSituation = res.data.variables.factoryVerificationSituation;
                this.factoryVerificationSituationFiles = res.data.variables.factoryVerificationSituationFiles;
              }
              if (res.data.variables.marketVehiclesList != null){
                this.marketVehiclesList = res.data.variables.marketVehiclesList;
              }


            }
          // 如果是责任单位填写永久方案和计划改善时间，则每一个责任单位人员回填自己的根因分析材料
          if (this.taskDefKey == "Activity_0urc73r" ||
            this.taskDefKey == "Activity_1m5s9p9" ||
            this.taskDefKey == "Activity_0mwkwpr" ||
            this.taskDefKey == "Activity_160anpw" ){
            this.receivedForm = res.data.variables.reasonAnalystDataList.find(item =>
              item.userId === res.data.startUserId
            ) || {};
          }
          if ( this.taskDefKey == "Activity_04naygw" ){
            this.hasMarketVehicle = res.data.variables.hasMarketVehicle;
            this.hasInventoryVehicle = res.data.variables.hasInventoryVehicle;
          }
          if (this.taskDefKey == "Activity_1my3ohs" ||
              this.taskDefKey == "Activity_1rsap6m" ||
              this.taskDefKey == "Activity_1qy6vq8" ||
              this.taskDefKey == "Activity_0e8nzr5" ||
              this.taskDefKey == "Activity_1jrizcd"){
              this.marketVehiclesList = res.data.variables.marketVehiclesList;
              this.inventoryVehicleHandStatusMessage = res.data.variables.inventoryVehicleHandStatusMessage;
          }
          // 临时措施回填
          if (
            this.taskDefKey == "Activity_1jmu1ad" ||
            this.taskDefKey == "Activity_1ayglqh" ){
            this.problemType = res.data.variables.problemType;
          }
          if (this.taskDefKey == "Activity_0ssx6ld" ||
            this.taskDefKey == "Activity_0zd71x8" ||
            this.taskDefKey == "Activity_0vmay8b" ||
            this.taskDefKey == "Activity_1nh3hwe" ||
            this.taskDefKey == "Activity_119d7lh" ||
            this.taskDefKey == "Activity_1nxlt2k" ||
            this.taskDefKey == "Activity_02i0f7v" ||
            this.taskDefKey == "Activity_09gocxv" ||
            this.taskDefKey == "Activity_1qakyfn" ||
            this.taskDefKey == "Activity_1q5528k" ||
            this.taskDefKey == "Activity_1n4y57e" ||
            this.taskDefKey == "Activity_0rr8epy" ||
            this.taskDefKey == "Activity_16fs05f"){ // 回填市场库存物料处置方案
            this.marketVehicles = res.data.variables.marketVehicles;
          }

          if (this.taskDefKey == "Activity_1klkn9j"){
            this.marketVehicles = res.data.variables.marketVehiclesList.find(item =>
              item.userId === res.data.startUserId
            ) || {};
          }

          if (this.taskDefKey == "Activity_009xhan" ||
            this.taskDefKey == "Activity_0q3vnwm" ||
            this.taskDefKey == "Activity_0ataghk"){// 回填缺失根因分析材料
            this.reasonAnalystData = res.data.variables.reasonAnalystData;
          }

          if (this.taskDefKey == "Activity_18nq1e5" || this.taskDefKey == "Activity_1vwk38v"){

            this.reasonAnalystData = res.data.variables.reasonAnalystDataList.find(item =>
              item.userId === res.data.startUserId
            ) || {};
            if (this.reasonAnalystData != {}){
              this.reconfirm = true;
            }
          }

        }else {
          this.$DonMessage.error(res.data.message);
        }
      })
    }

  },mounted() {
    console.log("switchMainAudit:"+this.taskId)
    this.loadTaskDetail();
  }
}
</script>
